import { styled as o, Typography as p, Box as c } from "@mui/material";
import { RONIN_VRF_ESIMATE_MINUTES as l, RONIN_VRF_ESIMATE_FEE as f } from "../../contract-lib/constants/contract.js";
import "../../temp-lib/styles/theme.js";
import { jsx as t, jsxs as a } from "react/jsx-runtime";
import "../../temp-lib/legacy/header/Header.js";
import "../../temp-lib/legacy/infoAccordion/InfoAccordion.js";
import "../../temp-lib/legacy/layout/Layout.js";
import "../../temp-lib/legacy/nav/Nav.js";
import "@metamask/detect-provider";
import "../../temp-lib/legacy/util/provider/Web3Instance.js";
import "jsonwebtoken";
import "ramda";
import "web3";
import "../../temp-lib/legacy/util/provider/WalletConnect.js";
import "../../download-lib/deserializes/yup/download.js";
import "../../temp-lib/components/account/adeptus/AdeptusCodeInput.js";
import "../../temp-lib/components/account/adeptus/AdeptusSuccessPopup.js";
import "../../temp-lib/components/account/share/ConfirmButton.js";
import "../../temp-lib/components/account/share/FormControlledPassword.js";
import "i18next";
import "react";
import "../../temp-lib/components/account/share/EmailOTPSender.js";
import "../../temp-lib/components/share/mui/Textfield.js";
import "react-hook-form";
import "../../temp-lib/components/account/share/ForgotPasswordButton.js";
import "../../temp-lib/components/account/share/PopupTitle.js";
import "../../temp-lib/components/account/share/SendEmailOTPButton.js";
import "../../temp-lib/components/footer/Footer.js";
import "../../temp-lib/components/role/EnoughRoleOnly.js";
import "../../temp-lib/components/share/apeiron/ApeironBlueButton.js";
import "../../temp-lib/components/share/apeiron/ApeironButtonDisableTip.js";
import "../../temp-lib/components/share/apeiron/ApeironChickenPopup.js";
import "../../temp-lib/components/share/apeiron/ApeironCloseButton.js";
import "../../temp-lib/components/share/apeiron/ApeironCookieConsent.js";
import "../../temp-lib/components/share/apeiron/ApeironEllipsisTypography.js";
import "../../temp-lib/components/share/apeiron/ApeironGoToButton.js";
import "../../temp-lib/components/share/apeiron/ApeironImageButton.js";
import "../../temp-lib/components/share/apeiron/ApeironInfinityDataGrid.js";
import h from "../../temp-lib/components/share/apeiron/ApeironLinkButton.js";
import "../../temp-lib/components/share/apeiron/ApeironLoopVideo.js";
import "../../temp-lib/components/share/apeiron/ApeironPagingDataGrid.js";
import "../../temp-lib/components/share/apeiron/ApeironReactPlayer.js";
import "../../temp-lib/components/share/apeiron/ApeironSectionTitle.js";
import "../../temp-lib/components/share/apeiron/ApeironTitle.js";
import "../../temp-lib/components/share/apeiron/ApeironTutorialDialog/ApeironTutorialDialog.js";
import "../../temp-lib/components/share/generic/CloseButton.js";
import "../../temp-lib/components/share/generic/IconText.js";
import "../../temp-lib/components/share/generic/ModalBox.js";
import "../../temp-lib/components/share/generic/Pagination.js";
import "../../temp-lib/components/share/generic/SearchEmptyState.js";
import "../../temp-lib/components/share/generic/Skeleton.js";
import "../../temp-lib/components/share/generic/TextInput.js";
import "next/script";
import "../../temp-lib/components/share/mui/Snackbar.js";
import "../../temp-lib/components/share/next/Image.js";
import "../../temp-lib/components/share/next/NextLink.js";
import "../../temp-lib/components/share/popup/InfoPopup.js";
import "../../temp-lib/constants/account.js";
import "../../temp-lib/constants/googleAnalytics.js";
import "../../temp-lib/constants/query.js";
import "../../temp-lib/contexts/account/AccountContext.js";
import "../../temp-lib/contexts/account/Geetest4Context.js";
import "../../temp-lib/contexts/adeptus/AdeptusContext.js";
import "@apollo/client";
import "@apollo/client/link/error";
import "@apollo/client/utilities";
import { useConfigContext as g } from "../../temp-lib/contexts/config/ConfigContext.js";
import "../../temp-lib/contexts/language/LanguageContext.js";
import "../../temp-lib/util/i18n/helper/locale.js";
import "path";
import "query-string";
import "p-retry";
import "ramda-adjunct";
import "../../temp-lib/contexts/share/LogicControlContext.js";
import { useTranslation as w, Trans as e } from "react-i18next";
import "../../temp-lib/contexts/fingerprint/FingerprintContext.js";
import "../../temp-lib/contexts/role/RoleContext.js";
import "../../temp-lib/contexts/share/DataGridContext.js";
import "../../temp-lib/contexts/share/MessageContext.js";
import "../../temp-lib/contexts/share/PersistQueryContext.js";
import "../../temp-lib/contexts/share/PreloadContext.js";
import "@tanstack/react-query";
import "../../temp-lib/contexts/share/ScreenLogContext.js";
import "../../config-lib/contexts/FrontendConfigContext.js";
import "../../config-lib/deserializes/yup/config.js";
import "../../config-lib/graphql/getFrontendConfig.js";
import "../../apostle-lib/deserializes/yup/apostle.js";
import "../../currency-lib/contexts/CurrencyContext.js";
import "../../temp-lib/contexts/web3/Web3Context.js";
import "../contexts/RoninNameServiceContext.js";
import "../../temp-lib/deserialize/yup/account.js";
import "../../temp-lib/deserialize/yup/chain.js";
import "../../temp-lib/deserialize/yup/locale.js";
import "../../temp-lib/deserialize/yup/page.js";
import "../../temp-lib/deserialize/yup/platform.js";
import "../../temp-lib/graphql/fragment/account.js";
import "date-fns";
import "date-fns/constants";
import "react-countdown";
import "next/router";
import "@walletconnect/utils";
import "@wagmi/core";
import "../../temp-lib/util/query/index.js";
import "../../temp-lib/deserialize/yup/adeptusCampaign.js";
import "../../temp-lib/graphql/query/getAdeptusCampaigns.js";
import "../../temp-lib/graphql/query/getPublicAccountDetail.js";
import "../../temp-lib/graphql/mutation/processEmailRegister.js";
import "../../currency-lib/constants/currency.js";
import "../../currency-lib/deserialize/yup/currency.js";
import "../../currency-lib/graphql/query/getCurrencyInfo.js";
import "../../currency-lib/graphql/query/getOffChainTokenBalances.js";
import "../../currency-lib/hooks/graphql/useGetTokenPriceToUSD.js";
import "../../temp-lib/util/erc20/index.js";
import "viem";
import "i18next-http-backend";
import "react-i18next/initReactI18next";
import "../../temp-lib/util/misc/formatNumberString.js";
import "../../temp-lib/util/yup/index.js";
import "../../temp-lib/wagmi/roninConnector.js";
const x = o(p)`
  font-size: 24px;
  font-weight: 500;
`, d = o(c)`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 18px;
  justify-content: center;
`, u = o(p)`
  strong {
    font-weight: 600;
  }
  font-weight: 300;
`, R = o(p)`
  strong {
    color: white;
    font-weight: 500;
  }
  color: #b1b3b3;
  font-size: 14px;
  line-height: 26px;
  font-weight: 300;
  white-space: pre-wrap;
`, T = o(h)`
  color: #ff5c00;
  font-size: 14px;
  font-weight: 400;
  vertical-align: unset;
`, vo = (i) => {
  const {
    title: r
  } = i;
  return /* @__PURE__ */ t(x, {
    children: r
  });
}, zo = (i) => {
  var n;
  const {
    skipDescription: r = !1
  } = i, {
    config: s
  } = g(), {
    t: m
  } = w();
  return /* @__PURE__ */ a(d, {
    children: [!r && /* @__PURE__ */ t(e, {
      children: /* @__PURE__ */ t(u, {
        children: m("wallet.ronin.vrf.description", {
          minute: l
        })
      })
    }), /* @__PURE__ */ t(R, {
      children: /* @__PURE__ */ t(e, {
        components: {
          learn: /* @__PURE__ */ t(T, {
            target: "_blank",
            url: (n = s.ronin) == null ? void 0 : n.walletVrf
          })
        },
        children: m("wallet.ronin.vrf.note", {
          fee: f
        })
      })
    })]
  });
};
export {
  zo as RoninVRFDescription,
  vo as RoninVRFTitle
};
//# sourceMappingURL=RoninVRFMessage.js.map
